import { createContext } from "react";
const ProductTagMasterContext = createContext({});

export default ProductTagMasterContext;
